// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m915vq{overflow-y:hidden}\n._18m91wug{overflow-y:auto}\n._1bsbauwl{width:100vw}\n._1reo15vq{overflow-x:hidden}\n._1reo1wug{overflow-x:auto}\n._4t3i1kxc{height:100vh}\n._o5721q9c{white-space:nowrap}\n._s7n4nkob{vertical-align:middle}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
